var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRedoBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Arrow Hook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M4.66634 3.16663C4.66634 2.89048 4.8902 2.66663 5.16634 2.66663H9.33301C10.6521 2.66663 11.669 3.21507 12.3462 4.04946C13.0134 4.87155 13.333 5.94669 13.333 6.99996C13.333 8.05322 13.0134 9.12836 12.3462 9.95046C11.669 10.7849 10.6521 11.3333 9.33301 11.3333H5.04011L6.68656 12.9797C6.88182 13.175 6.88182 13.4916 6.68656 13.6868C6.4913 13.8821 6.17472 13.8821 5.97945 13.6868L3.47945 11.1868C3.28419 10.9916 3.28419 10.675 3.47945 10.4797L5.97945 7.97974C6.17472 7.78448 6.4913 7.78448 6.68656 7.97974C6.88182 8.175 6.88182 8.49158 6.68656 8.68685L5.04011 10.3333H9.33301C10.3473 10.3333 11.0803 9.9234 11.5698 9.32029C12.0692 8.70489 12.333 7.86336 12.333 6.99996C12.333 6.13656 12.0692 5.29503 11.5698 4.67963C11.0803 4.07652 10.3473 3.66663 9.33301 3.66663H5.16634C4.8902 3.66663 4.66634 3.44277 4.66634 3.16663Z",
    fill: "#0B3E91"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRedoBlue);
export default __webpack_public_path__ + "static/media/icon-redo-blue.2c081fd9bb682f2e726757c419a85081.svg";
export { ForwardRef as ReactComponent };